export default __webpack_public_path__ + "static/media/AKM_6.a748ee94.png";